<tm-menubar-button [active$]="visible$"
                   (buttonClicked)="toggleAttributeList()"
                   [tooltip$]="title$"
                   icon="components_attribute_list"></tm-menubar-button>
